import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Field, Errors } from 'react-redux-form';
import classnames from 'classnames';

class Radio extends Component {
    render() {
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });

        let renderRadio = this.props.options.map(opt => {
            return (
                <div key={opt.name} className="form__item form__item--radio">
                    <label className="form__label">
                        <input
                            type="radio"
                            className="form__radio"
                            value={opt.code}
                        />
                        <span className="form__title">{opt.name}</span>
                    </label>
                </div>
            );
        });

        return (
            <div className={formRowClassNames}>
                <Field
                    model={this.props.model}
                    validators={this.props.validators}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
                >
                    <div className="form__row-title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </div>
                    {renderRadio}
                </Field>
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => ({
    valid: get(state.forms, `${model}.valid`, false),
    touched: get(state.forms, `${model}.touched`, false)
});

export default connect(mapStateToProps)(Radio);



// WEBPACK FOOTER //
// ./src/components/ui/radio.js